import React from 'react';
import '../styles/pages/Services.css';

const Services = () => {
  const services = [
    {
      id: '01',
      title: 'AI Automation',
      desc: 'Harness the power of LLMs and Python to automate repetitive tasks, build intelligent agents, and streamline complex business workflows.',
      icon: 'fa-robot',
      features: ['Custom LLM Integration', 'Workflow Orchestration', 'Python Scripting']
    },
    {
      id: '02',
      title: 'Mobile Apps',
      desc: 'Crafting high-performance, cross-platform mobile applications using Flutter that deliver seamless user experiences and robust functionality.',
      icon: 'fa-mobile-alt',
      features: ['Flutter Development', 'Cross-Platform Sync', 'Offline-First Apps']
    },
    {
      id: '03',
      title: 'Web Platforms',
      desc: 'Building scalable, modern web applications with React and Next.js, optimized for speed, SEO, and premium user engagement.',
      icon: 'fa-code',
      features: ['Full-stack React/Next.js', 'Responsive UI Design', 'Performance Tuning']
    },
    {
      id: '04',
      title: 'Cloud & Infrastructure',
      desc: 'Architecting secure and scalable cloud solutions using Oracle Cloud and AWS, ensuring high availability and robust backend performance.',
      icon: 'fa-cloud',
      features: ['Cloud Migration', 'API Development', 'Database Optimization']
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <span className="section-tag">Expertise</span>
          <h1 className="services-title">Turning Vision into <span className="text-gradient">Digital Reality</span>.</h1>
          <p className="services-subtitle">
            I combine engineering excellence with intelligent automation to build 
            solutions that don't just work—they scale and inspire.
          </p>
        </div>
      </section>

      <section className="services-grid-section">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div className="service-card-premium" key={service.id}>
                <div className="service-header">
                  <span className="service-number">{service.id}</span>
                  <div className="service-icon-wrap">
                    <i className={`fas ${service.icon}`}></i>
                  </div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                  <ul className="service-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx}><i className="fas fa-check-circle"></i> {feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="service-footer">
                  <a href="/contact" className="service-link">Get Started <i className="fas fa-arrow-right"></i></a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-card glass">
            <h2>Have a specific project in mind?</h2>
            <p>Let's discuss how we can bring your ideas to life with modern technology and automation.</p>
            <a href="/contact" className="btn btn-primary">Start a Conversation</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
